import React from "react";
import { PawPrint, Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-border/60 bg-muted/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_pawsitive-app-1/artifacts/54jk48in_ChatGPT%20Image%20Apr%2025%2C%202026%2C%2004_29_53%20PM.png"
              alt="Oh My Dog! Training with Heart. Results that Last."
              className="h-20 w-auto"
            />
          </Link>
          <p className="mt-4 text-muted-foreground max-w-md leading-relaxed">
            Psychology-based dog training for families across the U.S. and Mexico. From chaos to calm — one tail wag at a time.
          </p>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-primary">{t("nav.home")}</Link></li>
            <li><Link to="/request-training" className="hover:text-primary">{t("nav.contact")}</Link></li>
            <li><Link to="/login" className="hover:text-primary">{t("nav.login")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3">Coverage</h4>
          <p className="text-sm text-muted-foreground leading-relaxed">
            🇺🇸 Phoenix · Atlanta · Dallas · LA · NYC · Miami · Denver · Seattle<br />
            🇲🇽 Monterrey · CDMX · Guadalajara · Cancún · Tijuana · Querétaro · Puebla
          </p>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground flex items-center justify-center gap-2">
        Made with <Heart className="w-3.5 h-3.5 text-destructive fill-destructive" /> for happy dogs · © {new Date().getFullYear()} Oh My Dog!
      </div>
    </footer>
  );
}
